import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { DashboardConfig } from './core/config/dashboard.config';
import { ViewComponent } from './view/view.component';
import { ViewSelector } from './view/dom.constant';
import { JSON } from './core/json.type';

@Component({
  selector: 'ak-dashboard',
  encapsulation: ViewEncapsulation.None,
  template: `<ak-dashboard-view
    [nodes]="nodes"
    [config]="config"
    [templates]="{
      breadcrumbs: breadcrumbs,
      toolbar: toolbar
    }"
  ></ak-dashboard-view>`,
  styles: [],
})
export class DashboardComponent {
  @ContentChild(ViewSelector.BREADCRUMBS, { static: false })
  public breadcrumbs!: TemplateRef<any>;
  @ContentChild(ViewSelector.TOOLBAR, { static: false })
  public toolbar!: TemplateRef<any>;

  @ViewChild(ViewComponent) private view!: ViewComponent;
  @Input() public config!: DashboardConfig;
  @Input() public nodes: any[] = [];

  showContainerBorderLine(): void {
    this.view.showContainerBorderLine();
  }

  hideContainerBorderLine(): void {
    this.view.hideContainerBorderLine();
  }

  unSelectNode(): void {
    this.view.unSelectNode();
  }

  toJSON(): JSON<any> {
    return this.view.toJSON();
  }
}
